import Dashboard from "@/features/dashboard/dashboard";

export default function HomePage() {
  return <Dashboard />;
}
